module.exports = __webpack_public_path__ + "img/logoAvalizeBranca.dbb17bb1.png";